import {BaseService} from "./BaseService";
import {BearerApiClient} from "./APIClient";
import {PaginatedResponse} from "../types/PaginatedResponse";
import * as queryString from "query-string";
import {paginatedRequestQuery} from "../helper/paginatedRequest";
import {ServiceMethodOptions} from "../helper/PagingController";
import {TypeId} from "../types/TypeId";
import {PopulatedVehicle, Vehicle} from "../models/Vehicle";


interface GetAllQueryOptions  {
    search?: string;
}

export class VehicleService extends BaseService {

    public async getAll(options: ServiceMethodOptions, queryOptions: GetAllQueryOptions) {
        const client = BearerApiClient();

        const qs = queryString.stringify({
            ...paginatedRequestQuery(options),
            ...queryOptions,
        })

        return this.response<PaginatedResponse<PopulatedVehicle>>(
            client.get(this.BASE_URL + "/vehicles?" + qs, {
                signal: options.abortSignal
            }),
        )
    }

    public async delete(id: TypeId) {
        const client = BearerApiClient();

        return this.response<Vehicle>(
            client.delete(this.BASE_URL + `/vehicles/${id}`),
        )
    }

    public async get(id: TypeId) {
        const client = BearerApiClient();

        return this.response<Vehicle>(
            client.get(this.BASE_URL + `/vehicles/${id}`)
        )
    }

    public async create(payload: Partial<Vehicle>) {
        const client = BearerApiClient();

        return this.response<Vehicle>(
            client.post(this.BASE_URL + `/vehicles`, payload)
        )
    }

    public async update(id: TypeId, payload: Partial<Vehicle>) {
        const client = BearerApiClient();

        return this.response<Vehicle>(
            client.put(this.BASE_URL + `/vehicles/${id}`, payload)
        )
    }

}